var React = require('react');

function CloudBg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M5 37.999c-.728-1.53-3.073-2.748-3.613-7.173-.189-1.562-.696-3.146-.634-3.293-.221-1.63.155-3.247.48-4.87.484-2.419-.016-4.866 1.469-7.265.63-1.019.079-2.202.2-2.488.217-2.791.69-4.745 2.598-6.614 1.978-3.114 6.8-5.17 13.074-5.934 7.252.122 13.529.379 18.206 3.1 4.627 2.692 7.112 5.881 6.969 9.473-.03.754.082 1.491.482 2.244.603 1.131.581 2.329-.016 3.46-.528.994-.613 1.965-.105 2.926.431.815.449 1.635.25 2.428-.686 2.725-.504 5.426-.069 8.162.488 3.368-4.591 8.52-12.292 10.845C27.475 44.46 7.341 44.903 5 37.999z"}));
}

CloudBg.defaultProps = {"width":"45","height":"44"};

module.exports = CloudBg;

CloudBg.default = CloudBg;
